import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";

const datas = [
  {
  src: "https://www.businesslist.co.ke/img/cats/restaurants.jpg",
  width: 3,
  height: 3
}, {
  src: "https://m.economictimes.com/thumb/msid-82673285,width-1200,height-900,resizemode-4,imgsize-829462/1.jpg",
  width: 3,
  height: 3
}, {
  src: "https://www.myfoodtrip.com/wp-content/uploads/2020/05/restaurants.jpg",
  width: 3,
  height: 3
}, {
  src: "https://www.tripsavvy.com/thmb/YHKCk80sAaVNqCsmRXLZABZeMOk=/1440x863/filters:fill(auto,1)/132045025_1575383172669460_8723750846461443503_o-573305f0836c4744a37867458d78e888.jpg",
  width: 3,
  height: 3
}, {
  src: "https://www.tripsavvy.com/thmb/YkdW-JBXQUhaM0S-erVQI-w2-HM=/1080x750/filters:no_upscale():max_bytes(150000):strip_icc()/INTI-d0dbcdaa2beb4a9387481cf1ec65bf1f.jpg",
  width: 3,
  height: 3
}, {
  src: "https://media.architecturaldigest.com/photos/590cc6c3b3064307ffee59a4/master/w_3000,h_2000,c_limit/Tallest%20Restaurants%20in%20the%20World%207.jpg",
  width: 3,
  height: 3
}
]

function Gallery1() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
 
  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);
 
  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  return (
    <div>
      <Gallery photos={datas} onClick={openLightbox} />
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={datas.map(x => ({
                ...x,
                srcset: x.srcSet,
                caption: x.title
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  )
}

export default Gallery1